import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getShortDateDisplay } from '../../util/datetime';
import TimeTable from '../time-table/TimeTable';
import { selectPeriod } from '../ticket/ticketSlice';

import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import Link from '@mui/material/Link';
import { Link as RLink } from "react-router-dom";

import { ToolBar } from './RightToolBar';
import {
  selectTicket,
} from './ticketSlice';
import { useTicketByPeriodQuery } from '../../api/ticket';
import { toTimeRows } from '../time-table/timeTableSlice';
import TicketPaneViewer from './TicketPaneViewer';

const vcontentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	display: 'flex',
	//backgroundColor: 'grey',
};
const contentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	//overflow: 'auto',
	display: 'flex',
	//backgroundColor: 'grey',
};
const colOneStyle = {
	height: '100%',
	flexGrow: 5,
	width: '50%',
	//backgroundColor: '#eeeeee',
	//overflow: 'auto',
};
const colTwoStyle = {
	height: '100%',
	flexGrow: 4,
	//backgroundColor: 'green',
	width: '50%',
	//overflow: 'auto',
};
const viewStyle = {
	height: `calc(100% - 44px)`,
	overflow: 'auto',
	padding: 2,
	width: '100%',
	//height: '100%r',
	//backgroundColor: 'purple',
};

export function TicketByDate() {
	return (
		<MobileDesktopTicketByDate />
	);
}

export function MobileDesktopTicketByDate() {
	let {datum, id} = useParams();
	const dispatch = useAppDispatch();
	const minDate = (datum) ? new Date(datum) : new Date();
	minDate.setHours(0, 0, 0, 0);
	const maxDate = new Date(minDate.getTime() + 60 * 60 * 24 * 1000);
	const {
		data: pageResult,
		isLoading,
		isFetching,
		isSuccess,
		isError,
		error
	} = useTicketByPeriodQuery({min: minDate.toISOString(), max: maxDate.toISOString()}, { refetchOnMountOrArgChange: true});
	let yesterday = new Date(minDate.getTime() - 60 * 60 * 24 * 1000);
	const datumstr = (datum) ? datum: "";
	const tItems = useAppSelector(selectPeriod(minDate.toISOString(), maxDate.toISOString()));
	const tRows = toTimeRows(tItems);

	return (
		<Box sx={vcontentStyle}>
			<Box sx={{display: {xs: 'none', md: 'block'}}}>
				<ToolBar />
			</Box>
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<Box sx={{height: 45,display: {xs: 'none', md: 'block'}}}>
					</Box>
					<Box sx={viewStyle}>
						<Grid container spacing={2} sx={vcontentStyle}>
							<Grid size={{ xs: 12, md: 6}}>
				<Link to={"/ticket/bydate/" + yesterday.toISOString()} component={RLink}>Previous</Link>
				<Link to={"/ticket/bydate/" + maxDate.toISOString()} component={RLink}>Next</Link>
			<TimeTable data={tRows} refDate={minDate} linkTo={"parent"}
				titleLink={(id: string) => '/ticket/bydate/' + minDate.toISOString() + '/' + id}
			/>
							</Grid>
							<Grid size={{ xs: 12, md: 6}}>
						<Box>
							{/*
							<Metadata meta={page.metadata}/>
							*/}
							ktype
							<TicketPaneViewer id={id} />
						</Box>
							</Grid>
						</Grid>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export function DesktopTicketByDate() {
	let {datum, id} = useParams();
	const dispatch = useAppDispatch();
	const minDate = (datum) ? new Date(datum) : new Date();
	minDate.setHours(0, 0, 0, 0);
	const maxDate = new Date(minDate.getTime() + 60 * 60 * 24 * 1000);
	const {
		data: pageResult,
		isLoading,
		isFetching,
		isSuccess,
		isError,
		error
	} = useTicketByPeriodQuery({min: minDate.toISOString(), max: maxDate.toISOString()}, { refetchOnMountOrArgChange: true});
	let yesterday = new Date(minDate.getTime() - 60 * 60 * 24 * 1000);
	const datumstr = (datum) ? datum: "";
	const tItems = useAppSelector(selectPeriod(minDate.toISOString(), maxDate.toISOString()));
	const tRows = toTimeRows(tItems);

	return (
		<Box sx={vcontentStyle}>
			<ToolBar />
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
				<Link to={"/ticket/bydate/" + yesterday.toISOString()} component={RLink}>Previous</Link>
				<Link to={"/ticket/bydate/" + maxDate.toISOString()} component={RLink}>Next</Link>
			<TimeTable data={tRows} refDate={minDate} linkTo={"parent"}
				titleLink={(id: string) => '/ticket/bydate/' + minDate.toISOString() + '/' + id}
			/>
					</Box>
				</Box>
				<Box sx={colTwoStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						<Box>
							{/*
							<Metadata meta={page.metadata}/>
							*/}
							ktype
							<TicketPaneViewer id={id} />
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
